import { Page } from '@/core/architecture'

import { GlobalEventsTemplate } from './template'
import { useViewModel } from './viewModel'

export const GlobalEvents: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <GlobalEventsTemplate
      state={state}
      onFetchMoreCampaign={actions.onFetchMoreCampaign}
      onFetchMoreMission={actions.onFetchMoreMission}
    />
  )
}
